import { Inject, Injectable, Optional } from '@angular/core';
import { FhirApiService } from '../../../services/api/fhir-api.sevice';
import { DataFhirService } from '../../data-fhir.service';
import { HttpParamsObject } from '../../../services/api/api.service';
import { UserService } from '../../../services/user.service';
import {
  AddQuestionnaireEntry,
  AddQuestionnaireEntryAdapter,
} from './add-questionnaire.model';
import { ReducerManager, Store } from '@ngrx/store';
import { shareReplay } from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';
import { FhirResource } from 'fhir/r4';

@Injectable({ providedIn: 'root' })
export class AddQuestionnairesService extends DataFhirService<AddQuestionnaireEntry> {
  protected readonly defaultParamsObject: HttpParamsObject = {
    _sort: '-_lastUpdated',
    _getpageoffset: '200',
    _count: '200',
    status: 'active',
  };

  constructor(
    @Inject('dataName') @Optional() dataName: string,
    protected adapter: AddQuestionnaireEntryAdapter,
    protected fhirApi: FhirApiService,
    protected userService: UserService,
    protected store: Store,
    protected manager: ReducerManager,
  ) {
    super(
      dataName || 'questionnaires-add',
      adapter,
      fhirApi,
      userService,
      store,
      manager,
    );
  }

  addSelected$(
    patientId: string,
    practitionerId: string,
    patientOnly?: boolean,
  ): Observable<FhirResource[]> {
    let selectedItems: AddQuestionnaireEntry[];
    this.selectedData$
      .subscribe((data) => {
        selectedItems = data;
      })
      .unsubscribe();

    const addItems$: Observable<FhirResource>[] = selectedItems.map(
      (item: AddQuestionnaireEntry) => {
        item.patientOnly = patientOnly;
        this.setLoading(true);
        const addItem$ = this.addItem$(item, {
          patientId,
          practitionerId,
        }).pipe(shareReplay(1));

        addItem$.subscribe({
          next: (res) =>
            res
              ? this.deselectItem(item)
              : this.setError(new Error('Can not create new Entry')),
          error: (err) => this.setError(err),
          complete: () => this.setLoading(false),
        });

        return addItem$;
      },
    );

    return combineLatest(addItems$);
  }
}
